import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import Typography from '@/components/UI/typography/Typography';
import Button from '@/components/UI/button/Button';
import Box from '@/components/UI/box/Box';
import { copyText } from '@/helpers/copyText';
import TextField from '@/components/UI/textField/TextField';
import { Controller, useForm } from 'react-hook-form';
import { Regexes } from '@/helpers/regexes';
import styles from './FastLoginContainer.module.scss';
import { getEnvs } from '@/helpers/getEnvs';
type MobileInput = {
  mobile: string;
};
const FastLoginContainer = () => {
  const {
    control,
    handleSubmit,
    formState: {
      errors
    }
  } = useForm<MobileInput>();
  const [showNumberModal, setShowNumberModal] = useState(false);
  const [showCode, setShowCode] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const fastLoginRef = useRef(null);
  const isLogin = useSelector(state => state.bootstrapData?.data?.user_info?.uid);
  const submitHandler = async (data: MobileInput) => {
    setLoading(true);
    axios.request({
      method: 'POST',
      url: `${getEnvs()?.API_BASE_URL}/quick-register`,
      data: {
        mobile: data?.mobile
      }
    }).then(res => {
      setShowCode(true);
      setLoading(false);
    }).catch(err => {
      setShowCode(false);
      setLoading(false);
    });
  };
  const closeFastLogin = () => {
    setShowNumberModal(false);
    localStorage.setItem('special-discount-modal', 'hidden');
  };
  const handleClickOutside = e => {
    if (fastLoginRef.current && !(fastLoginRef.current as HTMLElement).contains(e.target as Node)) {
      closeFastLogin();
    }
  };
  useEffect(() => {
    if (!isLogin) {
      if (!(localStorage.getItem('special-discount-modal') === 'hidden')) {
        const timer = setTimeout(() => {
          document.addEventListener('mousedown', handleClickOutside);
          setShowNumberModal(true);
        }, 5000);
        return () => {
          clearTimeout(timer);
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }
    }
  }, [isLogin]);
  return <Box className={`${styles['fast-login']} ${showNumberModal ? styles['fast-login-show'] : ''}`} ref={fastLoginRef} data-sentry-element="Box" data-sentry-component="FastLoginContainer" data-sentry-source-file="FastLoginContainer.tsx">
      {!showCode ? <>
          <Box className={styles['fast-login-header']}>
            <Typography variant="bodyL_Bold">تخفیف ویژه</Typography>
            <Typography variant="bodyS">
              با وارد کردن شماره موبایل خود کد تخفیف 200 هزارتومانی دریافت کنید
            </Typography>
          </Box>
          <form onSubmit={handleSubmit(submitHandler)}>
            <Controller name={`mobile`} control={control} rules={{
          required: 'این فیلد ضروری میباشد',
          minLength: {
            value: 11,
            message: 'تعداد کاراکتر مجاز 11 می‌باشد'
          },
          maxLength: {
            value: 11,
            message: 'حداکثر تعداد کاراکتر مجاز 11 می‌باشد'
          },
          pattern: {
            value: Regexes.PHONE_NUMBER,
            message: 'لطفاً شماره همراه را به صورت  صحیح وارد کنید.'
          }
        }} render={({
          field
        }) => <TextField label="شماره موبایل" onClear={() => field.onChange('')} error={!!errors?.mobile} description={errors?.mobile?.message} sizes="small" {...field} />} />

            <Box className={styles['fast-login-footer']}>
              <Button format="primary" loading={loading} type="submit">
                ادامه
              </Button>
              <Button format="text" onClick={closeFastLogin}>
                بستن
              </Button>
            </Box>
          </form>
        </> : <>
          <Typography variant="bodyL_Bold" className={styles['success-step-text']}>
            شماره موبایل شما با موفقیت ثبت شد
          </Typography>
          <Box className={styles['discount-code-container']}>
            <Box className={styles['discount-code-container-text']}>
              <Typography variant="bodyL">
                کد تخفیف 200 هزارتومانی برای خرید اول بالای یک میلیون و پانصد
                هزار تومان
              </Typography>
              <Typography variant="bodyM">
                برای استفاده کد تخفیف را کپی کنید.{' '}
              </Typography>
            </Box>
            <Box className={styles['custom-divider']} />
            <Box className={styles['discount-code-container-code']}>
              <Box className={styles['copy-code-container']}>
                <Typography variant="bodyL_Bold" className={styles['code']}>
                  sh-su1403
                </Typography>
                <Button format="text" size="small" onClick={() => copyText('sh-su1403')}>
                  کپی کد تخفیف
                </Button>
              </Box>
            </Box>
          </Box>
          <Button format="outlined" onClick={closeFastLogin}>
            بستن
          </Button>
        </>}
    </Box>;
};
export default FastLoginContainer;